module.exports = __webpack_public_path__ + "img/upload2.4ccbe7a0.png";